import { settlementType } from "@/schemas/commonFields";
import { APIService, FetchListRequest } from "../../../services/api";
import { API } from "@/lib/api";
import { z } from "@/zod";

export type RoleBasedProjectSettlementType = z.infer<typeof settlementType>;

const RoleBasedProjectService = new APIService<
  RoleBasedProjectSettlementType[],
  RoleBasedProjectSettlementType[]
>(API.RoleBasedProject);

export const RoleBasedProjectSettlementTypeService = {
  getList: (
    fetchParams?: FetchListRequest<RoleBasedProjectSettlementType[]>,
  ) => {
    return RoleBasedProjectService.getList<RoleBasedProjectSettlementType[]>(
      fetchParams ?? {},
      "/settlement-types",
    );
  },
};
